import { stringify } from "qs";
import { emptyApi } from "./emptyApi";
import {
  FormInstanceStatus,
  IncorporationTrackerFilter,
} from "constants/incorporation";

export type IncorporationTrackerRow = {
  company_group_id: string;
  company_group_name: string;
  is_pre_incorporate: boolean;
  form_instance_id: string | null;
  form_template_name: string | null;
  display_title: string | null;
  is_published: boolean;
  status: FormInstanceStatus | null;
  current_stage_title: string | null;
  answered_questions_count: number;
  total_questions_count: number;
  is_completed: boolean;
  notes_count: number;
};

export type IncorporationTrackerResponse = {
  results: IncorporationTrackerRow[];
  total_pages: number;
  current_page: number;
  total_count: number;
  per_page: number;
};

export const incorporationApis = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getIncorporationTracker: build.query<
      IncorporationTrackerResponse,
      {
        search?: string | null;
        tracker_filter?: IncorporationTrackerFilter | null;
        page_num?: number;
        page_size?: number;
      }
    >({
      query: (params) => {
        const queryUrl = stringify(params, {
          skipNulls: true,
          addQueryPrefix: true,
        });
        return { url: `/api/inkle/incorporation/tracker/${queryUrl}` };
      },
      providesTags: ["INCORPORATION_TRACKER", "NOTES"],
    }),

    markPreIncorporate: build.mutation<
      { uuid: string; is_pre_incorporate: boolean },
      { groupId: string; isPreIncorporate: boolean }
    >({
      query: ({ groupId, isPreIncorporate }) => ({
        url: `/api/inkle/incorporation/group/${groupId}/pre_incorporate/`,
        method: "PUT",
        body: { is_pre_incorporate: isPreIncorporate },
      }),
      invalidatesTags: (result) =>
        result
          ? [
              { type: "SalesCrmCompanyGroups", id: "LIST" },
              "INCORPORATION_TRACKER",
            ]
          : [],
    }),

    assignIncorporationTemplate: build.mutation<
      { form_instance_id: string },
      { groupId: string; formTemplateId: string }
    >({
      query: ({ groupId, formTemplateId }) => ({
        url: `/api/inkle/incorporation/group/${groupId}/assign_template/`,
        method: "POST",
        body: { form_template_id: formTemplateId },
      }),
      invalidatesTags: ["INCORPORATION_TRACKER"],
    }),

    createIncorporationTemplate: build.mutation<
      { form_instance_id: string },
      { groupId: string }
    >({
      query: ({ groupId }) => ({
        url: `/api/inkle/incorporation/group/${groupId}/create_template/`,
        method: "POST",
      }),
      invalidatesTags: ["INCORPORATION_TRACKER", "INCORPORATION_TEMPLATES"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetIncorporationTrackerQuery,
  useMarkPreIncorporateMutation,
  useAssignIncorporationTemplateMutation,
  useCreateIncorporationTemplateMutation,
} = incorporationApis;
